module.exports = __webpack_public_path__ + "img/shipo-menu-fuel.b77359b2.svg";